<!-- for editing non-saved (draft) form values -->
<template>
  <v-modal @open="ensureFormFetched" modal-class="new-form-submission">
    <template :slot="NEW_FORM_SUBMISSION_MODAL_HASH">
      <div class="px-2 overflow-hidden">
        <h2>{{ title }}</h2>
      </div>

      <form-submission-table
        v-if="isPresent(currentValues)"
        v-model="currentValues"
        :groups="formGroups"
        :is-missable="isMissable"
      />

      <cta-row overlay-modal white-bg>
        <v-button block secondary @click="() => $emit('close')">
          {{ $t("components.modals.newFormSubmissionModal.done") }}
        </v-button>
      </cta-row>
    </template>
  </v-modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import { timeAgo, toDate } from "@/lib/date-utils"
import { isPresent } from "@/lib/utils"

import FormSubmissionTable from "@/components/FormSubmissionTable"

export const NEW_FORM_SUBMISSION_MODAL_HASH = "#new-form-submission"

export default {
  components: {
    FormSubmissionTable,
    CtaRow: () => import("@/components/CtaRow")
  },

  props: {
    formId: { type: Number, required: true },
    title: { type: String, required: true },
    isMissable: { type: Boolean, default: false }
  },

  model: {
    event: "close",
    prop: "show"
  },

  data() {
    return {
      isLoading: false,
      NEW_FORM_SUBMISSION_MODAL_HASH,
      currentItem: null
    }
  },

  computed: {
    ...mapGetters("forms", ["formById", "submissionValuesByForm"]),

    form() {
      return this.formById(this.formId)
    },

    formGroups() {
      return this.form?.form_groups || []
    },

    currentValues: {
      get() {
        return this.submissionValuesByForm(this.formId)
      },

      set(values) {
        this.setFormSubmissionValues({
          formId: this.formId,
          values: {
            ...this.currentValues,
            ...values
          }
        })
      }
    }
  },

  methods: {
    timeAgo,
    toDate,
    isPresent,

    ...mapMutations("forms", ["setFormSubmissionValues"]),
    ...mapActions("forms", ["fetchForm"]),

    ensureFormFetched() {
      if (!this.form) {
        this.isLoading = true

        this.fetchForm(this.formId).finally(() => (this.isLoading = false))
      }
    }
  }
}
</script>
